import { useEffect } from 'react'
import { useOneTrustCheckCompleted } from '../../analytics/react-gtm-hook'
import { useConsentStore } from './useStore'

export function useConsentGroupsListener() {
  const oneTrustCheckCompleted = useOneTrustCheckCompleted()
  const consentStore = useConsentStore()

  useEffect(() => {
    if (!oneTrustCheckCompleted || typeof window === 'undefined') return

    const handleConsentUpdate = (event: Event) => {
      const customEvent = event as CustomEvent
      consentStore.updateConsentGroups(customEvent.detail)
    }

    window.addEventListener("OneTrustGroupsUpdated", handleConsentUpdate)
    
    return () => {
      window.removeEventListener("OneTrustGroupsUpdated", handleConsentUpdate)
    }
  }, [oneTrustCheckCompleted, consentStore])
}